function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7.025,
    viewBox: "0 0 10 7.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M38-773.975v-1.063a1.318 1.318 0 0 1 .2-.718 1.239 1.239 0 0 1 .566-.481 8.963 8.963 0 0 1 1.488-.52 5.836 5.836 0 0 1 1.363-.158 5.765 5.765 0 0 1 1.357.158 9.039 9.039 0 0 1 1.482.52 1.273 1.273 0 0 1 .571.481 1.291 1.291 0 0 1 .209.718v1.063zm7.919 0v-1.063a1.831 1.831 0 0 0-.362-1.171 2.649 2.649 0 0 0-.95-.741 11.215 11.215 0 0 1 1.471.266 5.183 5.183 0 0 1 1.12.4 1.751 1.751 0 0 1 .588.532 1.24 1.24 0 0 1 .215.713v1.063zm-4.3-3.631a1.654 1.654 0 0 1-1.222-.475 1.654 1.654 0 0 1-.475-1.222 1.654 1.654 0 0 1 .475-1.222A1.654 1.654 0 0 1 41.62-781a1.654 1.654 0 0 1 1.222.475 1.654 1.654 0 0 1 .475 1.222 1.654 1.654 0 0 1-.475 1.222 1.654 1.654 0 0 1-1.222.475zm4.072-1.7a1.654 1.654 0 0 1-.475 1.222 1.654 1.654 0 0 1-1.222.475 2.521 2.521 0 0 1-.277-.017 1.2 1.2 0 0 1-.277-.062 1.857 1.857 0 0 0 .413-.7A2.833 2.833 0 0 0 44-779.3a2.633 2.633 0 0 0-.141-.9 2.4 2.4 0 0 0-.413-.718 2.382 2.382 0 0 1 .277-.057A1.907 1.907 0 0 1 44-781a1.654 1.654 0 0 1 1.222.475 1.654 1.654 0 0 1 .47 1.225z",
    transform: "translate(-38 781)",
    style: {
      fill: "#196cca"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.1c99e98c450412f648cee121392c91fe.svg";
export { ForwardRef as ReactComponent };